'use strict';

module.exports = {
  __init__: [ 'alignElements' ],
  alignElements: [ 'type', require(132) ]
};
